import { useEffect } from "react";
import { toast } from "react-toastify";

// Report categories
export const MIS_categories = [
  {
    value: "ota-partner",
    label: "OTA Partner",
    description: "Online Travel Agency partner insurance data",
  },
  {
    value: "probability-monitoring",
    label: "Probability Monitoring",
    description: "Probability analysis and monitoring data",
  },
  {
    value: "revenue",
    label: "Revenue",
    description: "Revenue analysis and financial performance data",
  },
  {
    value: "train-wise-performance",
    label: "Train-wise Performance",
    description: "Individual train performance metrics and statistics",
  },
  {
    value: "active-journey",
    label: "Active Journey",
    description: "Active journey tracking and monitoring data",
  },
  {
    value: "claim-rejection",
    label: "Claim Rejection",
    description: "Claim Rejection tracking and monitoring data",
  },
];

// Get the appropriate hook based on selected category
export const getCurrentHook = (
  selectedCategory,
  otaPartnerHook,
  probabilityMonitoringHook,
  revenueHook,
  trainPerformanceHook,
  activeJourneyHook,
  claimRejectionHook,
) => {
  switch (selectedCategory) {
    case "ota-partner":
      return otaPartnerHook;
    case "probability-monitoring":
      return probabilityMonitoringHook;
    case "revenue":
      return revenueHook;
    case "train-wise-performance":
      return trainPerformanceHook;
    case "active-journey":
      return activeJourneyHook;
    case "claim-rejection":
      return claimRejectionHook;
    default:
      return { isDownloading: false, handleDownload: () => {} };
  }
};

// Handle download functionality
export const handleMISDownload = async (selectedCategory, currentHook) => {
  if (!selectedCategory) {
    toast.warning("Please select a report category first");
    return;
  }

  const selectedReport = MIS_categories.find(
    (cat) => cat.value === selectedCategory,
  );
  if (!selectedReport) {
    toast.error("Invalid report category selected");
    return;
  }

  try {
    // Use the specific hook's download function
    await currentHook.handleDownload();
  } catch (error) {
    console.error("Download error:", error);
    toast.error(
      `Failed to download ${selectedReport.label} report. Please try again.`,
    );
  }
};

// MIS Download Logic (refactored to use individual exports)
export const useCreateMISDownloadLogic = (
  selectedCategory,
  setIsDownloading,
  otaPartnerHook,
  probabilityMonitoringHook,
  revenueHook,
  trainPerformanceHook,
  activeJourneyHook,
  claimRejectionHook,
) => {
  const currentHook = getCurrentHook(
    selectedCategory,
    otaPartnerHook,
    probabilityMonitoringHook,
    revenueHook,
    trainPerformanceHook,
    activeJourneyHook,
    claimRejectionHook,
  );

  // Update isDownloading state based on current hook
  useEffect(() => {
    setIsDownloading(currentHook.isDownloading);
  }, [currentHook.isDownloading, setIsDownloading]);

  const handleDownload = async () => {
    await handleMISDownload(selectedCategory, currentHook);
  };

  return {
    currentHook,
    handleDownload,
  };
};
